/* Cold Press Lab - flip cards + quick buy.
 *
 * Progressive enhancement only. With this file blocked the cards still render
 * on the back image, the title still links to the product page, and the size
 * buttons degrade to plain links. Nothing here is load-bearing.
 */
(function () {
  var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;

  function init(root) {
    if (!root || root.dataset.cpFlipReady === '1') return;
    root.dataset.cpFlipReady = '1';

    /* Touch has no hover, so the first tap on the image reveals the front and
       the second tap follows through to the product page. Desktop keeps the
       normal behaviour: hover reveals, click navigates immediately. */
    if (touch) {
      root.addEventListener('click', function (e) {
        var link = e.target.closest('.cp-flip__link');
        if (!link) return;
        var card = link.closest('.cp-flip__card');
        if (!card || !card.querySelector('.cp-flip__media.is-dual')) return;
        if (card.classList.contains('is-flipped')) return;
        e.preventDefault();
        card.classList.add('is-flipped');
      });
    }

    root.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('.cp-buy__size');
      if (sizeBtn) {
        var box = sizeBtn.closest('.cp-buy');
        box.querySelectorAll('.cp-buy__size').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === sizeBtn));
        });
        box.dataset.variant = sizeBtn.dataset.vid;
        var priceEl = box.closest('.cp-flip__card').querySelector('.cp-flip__price');
        if (priceEl && sizeBtn.dataset.price) priceEl.textContent = sizeBtn.dataset.price;
        var note = box.querySelector('.cp-buy__note');
        if (note) note.textContent = '';
        return;
      }

      var addBtn = e.target.closest('.cp-buy__add');
      if (addBtn) addToCart(addBtn);
    });
  }

  function addToCart(btn) {
    var box = btn.closest('.cp-buy');
    var note = box.querySelector('.cp-buy__note');
    var id = box.dataset.variant;

    if (!id) {
      if (note) note.textContent = 'Pick a size first.';
      var first = box.querySelector('.cp-buy__size:not(:disabled)');
      if (first) first.focus();
      return;
    }

    var original = btn.dataset.label || btn.textContent;
    btn.dataset.label = original;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.disabled = false;
        btn.classList.add('is-done');
        btn.textContent = 'Added';
        if (note) note.innerHTML = '<a href="/cart">View cart</a>';

        /* Ask the theme to refresh its cart UI. If nothing listens, the item is
           still in the cart and the View cart link covers it. */
        ['cart:update', 'cart:refresh', 'variant:add'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'cp-flip' } }));
        });

        window.setTimeout(function () {
          btn.classList.remove('is-done');
          btn.textContent = btn.dataset.label;
        }, 4000);
      })
      .catch(function () {
        /* Never strand the shopper - fall back to the product page. */
        btn.disabled = false;
        btn.textContent = btn.dataset.label;
        if (note) note.textContent = 'Could not add. Opening the product page.';
        var url = btn.dataset.url;
        if (url) window.location.href = url + '?variant=' + id;
      });
  }

  document.querySelectorAll('.cp-flip').forEach(init);

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.cp-flip') : null;
    if (el) init(el);
  });
})();
